import { createComponentExtension, createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { Entity } from '@backstage/catalog-model';

import { rootRouteRef } from './routes';

export const patchManagementPlugin = createPlugin({
  id: 'patch-management',
  routes: {
    root: rootRouteRef,
  },
});

export const PatchManagementPage = patchManagementPlugin.provide(
         createRoutableExtension({
           name: 'PatchManagementPage',
           component: () =>
             import('./components/PatchManagement/PatchManagementPage').then(
               m => m.PatchManagementPage,
             ),
           mountPoint: rootRouteRef,
         }),
       );
export const PatchManagementCard = patchManagementPlugin.provide(
         createComponentExtension({
           name: 'PatchManagementCard',
           component: {
             lazy: () =>
               import('./components/PatchManagement/PatchManagementCard').then(
                 m => m.PatchManagementCard as any,
               ),
           },
         }),
       );

export const isArtifactDataAvailable = (entity: Entity) => {
  const mavenCoordinate = entity?.metadata.annotations?.['leovegas.com/maven-coordinate'];
  const dockerImage = entity?.metadata.annotations?.['leovegas.com/docker-image'];
  return Boolean(mavenCoordinate || dockerImage);
};